module.exports = __webpack_public_path__ + "static/media/app-store.97ef4c6a.svg";